import { Injectable, OnDestroy } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import { from, of, Subscription } from 'rxjs'
import { SmartSearchService } from '../cms-search/smart-search.service'
import { CountryService } from '../../../site-context/facade/country.service'
import { switchMap, tap } from 'rxjs/operators'
import { environment } from '../../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class GotoRedirectService implements OnDestroy {

  sub = new Subscription()

  constructor (private router: Router,
               private cmsSearchService: SmartSearchService,
               private countryService: CountryService) {
  }

  init (): void {
    this.sub.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && event.url.includes('goto/')) {
        this.searchPageAndRedirect(event.url.split('goto/')[1])
      }
    }))
  }

  searchPageAndRedirect (url: string): void {
    this.sub.add(this.countryService.getActive().pipe(
      switchMap(country => from(
          this.cmsSearchService.preparedSearch(environment.smartSearchPIMIdentifierSearch)?.search(url, {
            language: country.toLowerCase()
          }) || of(undefined)).pipe(
          tap((result: any) => {
            if (result?.searchResults?.[0]?.result) {
              const seoUrl = result.searchResults[0].result['FS_pt_seoUrl']?.[0]
              this.router.navigate([seoUrl])
            }
          })
        )
      )
    ).subscribe())
  }

  ngOnDestroy (): void {
    this.sub.unsubscribe()
  }
}
